<template>
  <div class="c-list__results-top">
    <template v-if="pageInfo.pages > 1">
      {{ pageInfo.startItemIndex }} - {{ pageInfo.endItemIndex }} of
      {{ pageInfo.totalCount }} results
    </template>
    <template v-else-if="pageInfo.totalCount >= 0"> {{ pageInfo.totalCount }} results </template>
  </div>
</template>

<script>
export default {
  name: 'CIS-Resource-PagedListing-PageInfo',
  props: {
    pageInfo: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.c-list__results-top {
  text-align: right;
  flex-grow: 2;

  @include desktop-up {
    text-align: left;
  }
}
</style>
